<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <Title :title="'每月高峰期排队数'" class="margin-top"></Title>
    <Chart :cdata="cdata" :height="style.height"/>
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      style:{
        height:'300'
      },
      bigtitle:{
        CHN:'运营指标',
        ENG:'Operational indicators'
      },
      cdata: {
        category: [],
        rateData: [],
        id:"carAddChart",
        legendData:[{
              name:"平均排队数",
              icon: 'roundRect',
            }, {
              name:"最大排队数",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "平均排队数",
              type: "line",
              smooth: true,

              symbolSize: 1,
              yAxisIndex: 1,
              itemStyle: {
                color: "#90F3FF" 
              },
              areaStyle: {
                color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#00FFFF" },
                    { offset: 1, color: "#010D44" }
                ]),
                opacity: 0.5
              },
              data: []
            },
            {
              name: "最大排队数",
              type: "bar",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36A1FF" },
                    { offset: 1, color: "#1968FF" }
                  ])
                }
              },
              data: []
            },
        ],
        yAxisname:"(辆)"
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectStationLineNum(data)
    },
    selectStationLineNum(data={}){
      let _this = this;
      let params = {
        '@station_id':data.stationId,
        "enCode":"TiDB-zhandian-meiyuegaofengqipaiduirenshu"//TiDB-站点-每月高峰期
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let lineNum = [];
          let lineMaxNum = [];
          let xList = [];
          res.forEach(item=>{
            lineMaxNum.push(item.lineMaxNum);
            lineNum.push(item.lineNum);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = lineNum;//平均
          this.cdata.series[1].data = lineMaxNum;//最大
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>